/*eslint complexity: off*/
import React, {
  useContext,
  useEffect,
  useState
}                           from 'react';
import { useTranslation }   from 'react-i18next';
import LocalHospitalIcon    from '@material-ui/icons/LocalHospital';
import {
  specialties,
  createSpecialty,
  editSpecialty,
}                           from '~/config/routes';
import { toast }            from 'react-toastify';
import { historyPropType }  from '~/config/routerPropTypes';
import Request              from '~/providers/Request';
import Context              from './context';
import Paper                from '~/components/Paper';
import ModalDelete          from '~/components/ModalDelete';
import InputShow            from '~/components/InputShow';
import PaperButtons         from '~/components/PaperButtons';
import SpecialtyRecord      from '~/records/SpecialtyRecord';
import GridContainer        from '~/components/GridContainer';
import GridItem             from '~/components/GridItem';
import { AbilityContext }   from '~/contexts/Can';

const attrName = (attr) => SpecialtyRecord.hummanAttributeName(attr);

function ShowSpecialty({history}) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [ record, setRecord ] = useState(new SpecialtyRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord(record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/specialties/${id}`, {})
      .then( response => {
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete(){
    setLoading(true);
    Request.del(`/admin/specialties/${id}`)
    .then(() => {
      toast.success(t('delete-toast-success'));
      history.push(specialties.spec);
    })
    .catch(() => {
      setLoading(false);
      toast.error(t('delete-toast-fail'));
    });
    setModal(false);
  }

  return (
    <Paper
      Icon={ LocalHospitalIcon }
      iconColor="blue"
      title={t('specialties.defSingular')}
      loading={ loading }
      actions={
        <PaperButtons
          id={ id }
          setModal={ability.can('delete', 'Specialties') ? setModal : null}
          backRoute={ specialties }
          newRoute={ability.can('new', 'Specialties') ? createSpecialty : null}
          editRoute={ability.can('edit', 'Specialties') ? editSpecialty : null}
        />}
      >
          <GridContainer>
            <GridItem xs={4} md={4}>
              <InputShow
                label={attrName('name')}
                value={record.get('name')}
              />
            </GridItem>
            <GridItem xs={6} md={2}>
              <InputShow
                label={attrName('is_active')}
                value={record.get('is_active') }
                type='boolean'
              />
            </GridItem>
            <GridItem xs={6} md={3}>
              <InputShow
                label={attrName('appointment_duration')}
                value={record.get('appointment_duration') }
              />
            </GridItem>
            <GridItem xs={6} md={3}>
              <InputShow
                label={attrName('appointment_interval')}
                value={record.get('appointment_interval') }
              />
            </GridItem>
            <GridItem xs={6} md={3}>
              <InputShow
                label={attrName('external_id_ids')}
                value={record.get('external_id_ids')}
              />
            </GridItem>
          </GridContainer>
        <ModalDelete
          modal={modal}
          onClose={() => {
            setModal(false);
          }}
          name={record.get('name')}
          id={record.get('id')}
          deleteAction={handleDelete}
        />
      </Paper>
  );
}

  ShowSpecialty.propTypes={
    history: historyPropType,
  };

export default ShowSpecialty;
